import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './About.css';
import { faStudiovinari } from '@fortawesome/free-brands-svg-icons';

function About() {
  return (
    <div>
        <h4>About</h4>
        <FontAwesomeIcon icon={faStudiovinari} size="6x" />
        <div>
            {/* <p>A product studio is a platform for repeatable creation and growth of successful products. At the same time, it is a company model, which has two wings: clients' and its own software products. They are integrally connected and complement each other.</p> */}
        <p>Pandora-Inc Studios isn't your average developer. We're a product studio, a unique breed that goes beyond creating pixelated masterpieces. We unlock the secrets of repeatable success, building a symphonic ecosystem where your game thrives and our own software products sing in harmony.

Think of us as two wings, soaring together.</p>

<p> One wing beats for you, our clients. We bring your game visions to life, crafting engaging experiences that captivate players and conquer the mobile world. Our proven playbook, honed through countless victories, guides each step of the journey, ensuring sustainable, data-driven growth.

But the other wing? That's where our magic truly takes flight. We pour our expertise into forging our own software tools, like [insert examples of specific products]. These aren't just shiny toys – they're integral parts of our success formula, optimizing everything from development to user engagement. You reap the benefits, both as powerful tools at your disposal and as the fuel that continuously improves our entire ecosystem.
</p>
<p>
It's a beautiful dance, a win-win symphony. Your success fuels our innovation, and our innovation fuels your growth. It's a closed loop of brilliance, constantly evolving and pushing the boundaries of what's possible.

So, what are you waiting for? Join us on the dance floor of repeatable product success. Let's craft a game that shines brighter than a supernova, leaving players breathless and the competition green with envy.

Because at Pandora-Inc Studios, success isn't a gamble – it's a carefully orchestrated masterpiece.</p>
        </div>
    </div>
  )
}

export default About